import { useEffect, useState } from 'react';
import { useOutletContext, useParams, Navigate } from 'react-router-dom';

export default function ModuleHost() {
  const { moduleCode } = useParams();
  const { modules, moduleLoaders } = useOutletContext<{
    modules: string[];
    moduleLoaders: Record<string, () => Promise<{ default: React.ComponentType }>>;
  }>();
  const [Comp, setComp] = useState<React.ComponentType | null>(null);

  useEffect(() => {
    // Clear the previous module so it doesn't render against the new URL —
    // otherwise its useParams() observes the wrong subPath and may redirect
    // back into its own module, fighting the new module's mount.
    setComp(null);
    if (!moduleCode || !modules.includes(moduleCode) || !moduleLoaders[moduleCode]) return;
    let active = true;
    moduleLoaders[moduleCode]().then((m) => { if (active) setComp(() => m.default); });
    return () => { active = false; };
  }, [moduleCode, modules, moduleLoaders]);

  if (!moduleCode || !modules.includes(moduleCode)) return <Navigate to=".." replace />;
  if (!Comp) return <div>Loading module…</div>;
  return <Comp />;
}
